export const validation = {
  maxTitleChar: 120,
  maxParagraphChar: 1500,
  maxSlideTitleChar: 50,
  maxSlideContentChar: 650,
  slides: {
    min: 1,
    max: 10
  }
}
